import axiosClient from "./axiosClient";

const brandService = {
    getAllBrands: async () => {
        try {
            const response = await axiosClient.get('brands.php');
            return response.data; 
        } catch (error) {
            console.error("Brand Service Error [getAllBrands]:", error);
            throw error;
        }
    },
    
    getBrandDetail: async (id) => {
        const response = await axiosClient.get(`brands.php?id=${id}`);
        return response.data;
    },
    
    createBrand: async (data) => {
        // Matches the 'else' block in your PHP POST switch
        const response = await axiosClient.post('brands.php', data);
        return response.data;
    },

    updateBrand: async (id, data) => {
        // Matches: elseif ($type === 'update' && $id)
        // FIX: Added .data return
        const response = await axiosClient.post(`brands.php?id=${id}&type=update`, data);
        return response.data;
    },
    deleteBrand: async (id) => {
    const response = await axiosClient.delete(`brands.php?id=${id}`);
    return response.data;
},

getBrandStats: async (id) => {
    const response = await axiosClient.get(`brands.php?id=${id}&type=stats`);
    return response.data; // Expected: { task_count: 5 }
},

    addService: async (brandId, serviceData) => {
        // Matches: elseif ($type === 'service')
        const response = await axiosClient.post(`brands.php?type=service`, { 
            service_name: serviceData.service_name, 
            brand_id: brandId 
        });
        return response.data;
    },

    updateService: async (serviceId, data) => {
        // Matches: if ($type === 'service_update' && $id)
        const response = await axiosClient.post(`brands.php?id=${serviceId}&type=service_update`, data);
        return response.data;
    },

    deleteService: async (serviceId) => {
        // Matches: case 'DELETE': if ($type === 'service' && $id)
        const response = await axiosClient.delete(`brands.php?id=${serviceId}&type=service`);
        return response.data;
    }
};

export default brandService;